<template>
  <div class="container mt-6">
    <generic-table
      ref="datatable"
      :title="$t('roles')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/access/role/datatables"
    />

    <role-modal ref="role_modal" @success="refresh" />
  </div>
</template>

<script>
import RoleModal from "./role_modal/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import { generate_datatables_button } from "@/utils";
import {
  // session_token,
  // api_host,
  // register_listener,
  confirm_deletion_dialog,
  // confirm_activation_dialog,
  del,
  // post,
  error_message,
} from "@/utils";

export default {
  name: "AccessRoles",
  components: { GenericTable, RoleModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("description"),
          name: "description",
          data: (row) => {
            return row.description || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let r = `<p class="buttons">`;

            r += generate_datatables_button({
              args: { uuid: row.uuid },
              tooltip: v.$t("delete"),
              icon: "fa fa-trash",
              icon_class: "is-small has-text-danger",
              click: function (e) {
                let uuid = e.detail.uuid;
                confirm_deletion_dialog(
                  v.$t("are you sure to delete role?"),
                  v,
                  () => {
                    del("/access/role", { uuid: uuid })
                      .then(() => {
                        v.refresh();
                      })
                      .catch((error) => {
                        error_message(error);
                      });
                  }
                );
              },
            });

            r += generate_datatables_button({
              args: { uuid: row.uuid },
              tooltip: v.$t("edit"),
              icon: "fa fa-edit",
              icon_class: "is-small",
              click: function (e) {
                let uuid = e.detail.uuid;
                v.$refs.role_modal.edit_mode(uuid);
              },
            });

            r = `${r}</p>`;
            return r;
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.role_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    // let v = this;
    // v.init();
  },
};
</script>

<style></style>
